// extracted by mini-css-extract-plugin
module.exports = {"addInput":"index-module--addInput--2z-N6","warning":"index-module--warning--JbW7f"};